import React from 'react';
import { Tooltip } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { injectIntl } from 'react-intl';
import type { StudioWatermarkLogoId } from '../../../constants';
import LogoWatermarkIcon, { STUDIO_WATERMARK_LOGOS } from '../../LogoWatermark';

interface LogoWatermarkControlProps {
  intl: any;
  logo?: StudioWatermarkLogoId | null;
  onChangeLogo: (logo: StudioWatermarkLogoId | null) => void;
}

const LogoWatermarkControl: React.FC<LogoWatermarkControlProps> = ({ intl, logo, onChangeLogo }) => (
  <div>
    <div className="studio-watermark-grid">
      {STUDIO_WATERMARK_LOGOS.map(option => {
        const label = intl.formatMessage({ id: option.labelId });
        const selected = option.id === logo;

        return (
          <Tooltip key={option.id} title={label} arrow>
            <button
              type="button"
              className={`studio-watermark-option${selected ? ' selected' : ''}`}
              aria-label={label}
              aria-pressed={selected}
              onClick={() => onChangeLogo(selected ? null : option.id)}
            >
              <LogoWatermarkIcon logo={option.id} size={28} />
              {selected ? <CheckRoundedIcon className="studio-watermark-check" /> : null}
            </button>
          </Tooltip>
        );
      })}
    </div>
  </div>
);

export default injectIntl(LogoWatermarkControl);
